<div class="message-container" [ngClass]="[type]">
  <div class="row-layout">
    <div class="message-content">
      <span class="message-icon">
        <i [class]="getIconClass()"></i>
      </span>
      <span class="message-text">{{ text }}</span>
    </div>

    <div class="message-actions">
      <button *ngIf="actionText" class="action-button" (click)="onAction()">
        {{ actionText }}
      </button>

      <button
        *ngIf="closable"
        class="close-button"
        (click)="onClose()"
        aria-label="Close"
      >
        ✕
      </button>
    </div>
  </div>
</div>
